/**
 * Contexto sintético = mismo shape que `TenantAccessContextResolver` vacío / fallback HTTP.
 * Se usa si el GET tenant-context falla (red, 404, etc.).
 *
 * Objetivo: tenants que no usan divisiones ni permisos custom no pierden comportamiento previo
 * (permisos por rol fijo; PDF vía `canShowTaskPdfExportForUi` cuando status no es `loaded`).
 */
export type TenantAccessContextLoadStatus = 'loaded' | 'failed';

export function getSyntheticTenantAccessContext() {
  return {
    effectiveDivisionIds: [] as string[],
    directDivisionIds: [] as string[],
    isDivisionTransversalGlobal: true,
    featureKeys: [] as string[],
    customPermissionIds: [] as string[],
    divisionAssignmentInMobileEnabled: false,
    divisionNamesById: {} as Record<string, string>,
    allDivisionIds: [] as string[],
  };
}
